import { useAuth } from "@/hooks/use-auth";
import { ShieldAlert } from "lucide-react";

/** Renders children only if the current user is an admin; otherwise shows access denied. */
export function AdminGuard({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  if (!user?.is_admin) {
    return (
      <div className="flex flex-col items-center justify-center h-full gap-3 text-muted-foreground">
        <ShieldAlert className="w-10 h-10" />
        <p className="text-lg font-medium">Access Denied</p>
        <p className="text-base">You need admin privileges to view this page.</p>
      </div>
    );
  }
  return <>{children}</>;
}
